import DomainManager from '../../shared/utils/DomainManager';

import { apiClient } from './apiClient';

export type NewMessageResponse = {
  new_messages: boolean;
};

export const fetchFreshMessage = (targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);

  return apiClient.get<NewMessageResponse>(
    `${domainManager.getTravelerServiceDomain()}/messenger/new_messages`
  );
};
